// Static landing page served directly from public/index.html (source of truth: /app/site/index.html)
const root = document.getElementById("root");
if (root) root.remove();
